import { ProfileModel as ProfileModelCore } from "core-kit";

export interface ProfileModel extends ProfileModelCore {}
